import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { PaletteSection } from '@/components/landing/palette-section'
import { VariationsSection } from '@/components/landing/variations-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <VariationsSection />
            <PaletteSection />
        </Layout>
    )
}

export default Home
